// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bountyId: __t.u64().primaryKey().name("bounty_id"),
  target: __t.identity(),
  contractorKind: __t.string().name("contractor_kind"),
  contractorId: __t.u64().name("contractor_id"),
  contractorLabel: __t.string().name("contractor_label"),
  placedBy: __t.identity().name("placed_by"),
  spend: __t.i64(),
  tier: __t.u8(),
  hunterName: __t.string().name("hunter_name"),
  hunterHp: __t.i32().name("hunter_hp"),
  hunterMaxHp: __t.i32().name("hunter_max_hp"),
  state: __t.string(),
  placedAt: __t.timestamp().name("placed_at"),
  attackAt: __t.timestamp().name("attack_at"),
  lastHitAt: __t.timestamp().name("last_hit_at"),
  resolvedAt: __t.timestamp().name("resolved_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
